<pre>
{{settings | json}}
</pre>